import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = [];

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (_, { payload: { gender = [] } }) =>
      Array.isArray(gender) ? gender : [gender],
  },
  initialState,
);

export const getGenderFilter = state => state;
